import {mapRunningTime, mapRunningTimeDto} from '@domain/shared'
import {omit} from 'lodash'
import moment from 'moment-timezone'

import {Stoppage, StoppageDto} from '../types'

export const mapPartialStoppage = (
  response: Partial<StoppageDto>,
  timezone: string
): Partial<Stoppage> => {
  return {
    ...omit(response, ['stoppageStart', 'stoppageEnd', 'pxTrendStoppage']),
    ...(response.stoppageStart && {stoppageStart: moment.utc(response.stoppageStart).tz(timezone)}),
    ...(response.stoppageEnd && {stoppageEnd: moment.utc(response.stoppageEnd).tz(timezone)}),
    ...(response.pxTrendStoppage && {
      pxTrendStoppage: mapRunningTime(response.pxTrendStoppage, timezone)
    })
  }
}

export const mapStoppageDto = (data: Partial<Stoppage>): Partial<StoppageDto> => ({
  ...omit(data, ['stoppageStart', 'stoppageEnd', 'pxTrendStoppage']),
  ...(data.stoppageStart && {stoppageStart: data.stoppageStart.toISOString()}),
  ...(data.stoppageEnd && {stoppageEnd: data.stoppageEnd.toISOString()}),
  ...(data.pxTrendStoppage && {pxTrendStoppage: mapRunningTimeDto(data.pxTrendStoppage)})
})

export const mapStoppage = (data: StoppageDto, timezone: string): Stoppage => ({
  ...data,
  stoppageStart: moment.utc(data.stoppageStart).tz(timezone),
  stoppageEnd: data.stoppageEnd ? moment.utc(data.stoppageEnd).tz(timezone) : undefined,
  pxTrendStoppage: data.pxTrendStoppage && mapRunningTime(data.pxTrendStoppage, timezone)
})
